import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom'; // Import the hook
import { Percent, Maximize, Home } from 'lucide-react';

const calculators = [
  { 
    title: "Brokerage Calculator", 
    text: "Calculate real estate brokerage fees and taxes instantly.",
    icon: <Percent size={32} className="text-primary" />,
    path: "/calculator/brokerage_calculator" // Route path
  },
  { 
    title: "Plot Calculator", 
    text: "Convert grounds, cents, and square feet for land measurement.",
    icon: <Maximize size={32} className="text-success" />,
    path: "/calculator/plot_calculator"
  },
  { 
    title: "Housing Loan", 
    text: "Estimate your monthly EMIs and total interest for home loans.",
    icon: <Home size={32} className="text-danger" />,
    path: "/calculator/home_loan_calculator"
  },
  // ... add paths for others
];

function Calculators() {
  const navigate = useNavigate(); // Initialize navigation

  return (
    <Container className="py-5">
      <h2 className="mb-5 fw-bold text-dark">Calculators</h2>
      
      <Row xs={1} md={2} lg={3} className="g-4">
        {calculators.map((calc, idx) => (
          <Col key={idx}>
            <Card className="h-100 shadow-sm border-0 shadow-hover" style={{ borderRadius: '15px' }}>
              <Card.Body className="p-4 d-flex flex-column">
                <div className="mb-4 p-3 bg-light rounded-3 d-inline-block" style={{ width: 'fit-content' }}>
                  {calc.icon}
                </div>
                
                <Card.Title className="fw-bold fs-4 mb-3">{calc.title}</Card.Title>
                <Card.Text className="text-muted mb-4 flex-grow-1">
                  {calc.text}
                </Card.Text>
                
                <Button 
                  variant="outline-primary" 
                  className="fw-semibold py-2 px-4 rounded-pill w-75"
                  onClick={() => navigate(calc.path)} // This triggers the route
                >
                  Calculate
                </Button>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default Calculators;